import GenderChart from './GenderChart';
export default GenderChart;
